// src/utils/auth.js
export const isTokenExpired = (token) => {
  if (!token || typeof token !== 'string' || token.split('.').length !== 3) {
    return true;
  }
  try {
    let base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) base64 += '=';
    const payload = JSON.parse(atob(base64));
    const currentTime = Date.now() / 1000;
    return payload.exp < currentTime;
  } catch (e) {
    return true;
  }
};
  
// src/utils/auth.js
export const logout = async () => {
  const token = localStorage.getItem('token');

  if (token) {
    try {
      await fetch('https://be-lb.chitragupta.co/logout', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Ensure refreshToken cookie is sent
      });
    } catch (err) {
      console.error('Logout API call failed:', err);
      // Even if the API fails, proceed to clear the token
    }
  }

  localStorage.removeItem('token');
  window.location.reload();
};